import { render, staticRenderFns } from "./combineDataList.vue?vue&type=template&id=34433436&scoped=true"
import script from "./combineDataList.vue?vue&type=script&lang=js"
export * from "./combineDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34433436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34433436')) {
      api.createRecord('34433436', component.options)
    } else {
      api.reload('34433436', component.options)
    }
    module.hot.accept("./combineDataList.vue?vue&type=template&id=34433436&scoped=true", function () {
      api.rerender('34433436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/devconfig/combineDataList.vue"
export default component.exports